(function($){
	
	$.fn.printSection = function() {
		var elem = $(this),
			target = $('.js-print__target');
			
		var init = function() {
			
			elem.on('click', function(evt) {
				evt.preventDefault();
				
				if(target.any()) {
					
					var currentDocTitle = document.title;
					
					if(elem.attr('data-document-title')) {
						document.title = elem.attr('data-document-title');
					}
					
					target.get(0).contentWindow.print();
					
					document.title = currentDocTitle;
					
				};
				
			});
		};
		
		init();
		return this;
	};
	
}($));